<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import { devices } from '../../../stores';
	import type { FlowNode, NodeData } from '../types/flow-types';
	import { getEffectiveNodeDisplayLabel } from '../PropertyEditors/helpers/LabelGenerator';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	function resolveExecutionMode(d: NodeData): string {
		if (d.executionMode) return d.executionMode as string;
		const ctId = (d.cond_type as any)?.id;
		if (ctId === 1 || ctId === 'once') return 'once';
		if (ctId === 2 || ctId === 'any') return 'any';
		if (ctId === 3 || ctId === 'repeat') return 'repeat';
		return 'once';
	}

	$: executionMode = resolveExecutionMode(data);
	$: holdOff = Number(data.hold_off ?? 5);
	$: isOnce = executionMode === 'once';

	$: modeLabel = (() => {
		switch (executionMode) {
			case 'any':
				return 'On any change';
			case 'repeat':
				return 'Repeatedly';
			case 'once':
			default:
				return 'Once';
		}
	})();

	$: cardTitle = (() => {
		$devices;
		return getEffectiveNodeDisplayLabel({
			id,
			type: 'trigger',
			position: { x: 0, y: 0 },
			data,
		} as FlowNode);
	})();
	$: labelList =
		isOnce && holdOff > 0
			? [{ icon: 'fas fa-clock', value: `Valid ${holdOff} min`, iconColor: 'secondary' as const }]
			: undefined;
</script>

<BaseNode
	{id}
	type="trigger"
	{data}
	{selected}
	{validated}
	{errors}
	hideInputPort={true}
	{cardTitle}
	subtitle={modeLabel}
	subtitleType="primary"
	{labelList}
	{...$$restProps}
/>
